/**
 * FAQ item structure
 */
export interface FAQItem {
  question: string
  answer: string
}

/**
 * Adapted FAQ input props (matches what FAQ component accepts)
 */
export interface AdaptedFAQInputProps {
  title?: string
  description?: string
  items: FAQItem[]
  variant?: 'accordion' | 'grid' | 'list'
}

/**
 * Block FAQ item structure (matches the upstream shadcn-ui-blocks faq block)
 */
export interface BlockFaqItem {
  id: string
  question: string
  answer: string
}

/**
 * Raw input props of the upstream shadcn-ui-blocks faq block
 */
export interface BlockFaq1Props {
  heading: string
  description?: string
  items: BlockFaqItem[]
}

/**
 * Map a single FAQ item to block FAQ item
 */
export function mapFAQItemToBlock(item: FAQItem, index: number): BlockFaqItem {
  return {
    id: `faq-${index}`,
    question: item.question,
    answer: item.answer,
  }
}

/**
 * Map adapted FAQ props to the upstream block props shape
 */
export function mapFAQProps(props: AdaptedFAQInputProps): BlockFaq1Props {
  return {
    heading: props.title ?? 'Frequently asked questions',
    description: props.description,
    items: props.items.map(
      (item: FAQItem, index: number): BlockFaqItem =>
        mapFAQItemToBlock(item, index)
    ),
  }
}
